import { Injectable } from '@angular/core';
import { WAREHOUSE_FIND_MANY, WAREHOUSE_SECTION_FIND_MANY } from '@core/graphl-queries/warehouse.query';
import { Apollo } from 'apollo-angular';
import { environment } from 'environments/environment';
import { BehaviorSubject, ReplaySubject, of, switchMap, map } from 'rxjs';
import { Storage } from '@targx/libs/storage';
@Injectable({ providedIn: 'root' })
export class WarehouseService {
  constructor(private readonly _apollo: Apollo) { }

  private _warehouses: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  get warehouses() {
    return this._warehouses.asObservable();
  }

  get warehouse() {
    return Storage.get(environment.KEY_WAREHOUSE_SELECTED)
  }

  findMany(args?: { orderBy?: any; where?: any; limit?: number; skip?: number }) {
    return this._apollo
      .watchQuery<any>({
        query: WAREHOUSE_FIND_MANY,
        variables: args,
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        switchMap(({ data }) => {
          const warehouses = data.WarehouseFindMany;
          this._warehouses.next(warehouses);
          return of(warehouses);
        })
      );
  }

  /** Sections ("Frente de Loja" areas) belonging to a single warehouse. */
  findSections(warehouseId: number) {
    return this._apollo
      .query<any>({
        query: WAREHOUSE_SECTION_FIND_MANY,
        variables: { where: { warehouseId: { equals: +warehouseId } }, orderBy: [{ name: 'asc' }] },
        fetchPolicy: 'network-only',
      })
      .pipe(map(({ data }) => data.WarehouseSectionFindMany ?? []));
  }
}
